import styled from 'styled-components'

type ImageProps = {
  height: string
  width: string
  objectFit: string
}

const Image = styled.img<ImageProps>`
  width: ${({ width }) => width};
  ${({ height }) => height && `height:${height};`}
  object-fit: ${({ objectFit }) => objectFit}
`

export { Image }
